module.exports = __webpack_public_path__ + "img/wheelchair.1219c1a5ee3c8839a113649d521de380.png";